module.exports = __webpack_public_path__ + "media/images/flags/pg-8957a2a250a947471b7585b9e440a111.svg";